<template lang="pug">
Auth(@loggedIn="onLoggedIn")
  HeaderRoot(:content="headerContent")
  div.wrap-top
    ModuleTop
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-top {
  width: 100%;
  min-height: $device_height;
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import HeaderRoot from '@/components/shared/HeaderRoot'
import ModuleTop from '@/components/module/ModuleTop'

export default {
  components: {
    Auth,
    HeaderRoot,
    ModuleTop
  },
  data () {
    return {
      headerContent: {
        title: ''
      }
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    onLoggedIn () {
    
    }
  }
}
</script>
